import PropTypes from "prop-types";
import React, { Component } from "react";
import { Alert, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
// actions
import { loginApiError, loginUser } from "../../store/actions";
import errorIcon from "../../assets/images/alerts/error.svg";

import '../../styles/login.css';
import { InputSwitch } from "primereact/inputswitch";
import { Message } from "primereact/message";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedClient: null,
      record: {
        message: "",
        code: "",
        details: "",
        correlationId: "",
        validationResults: [],
        checked: false
      }
    };
    //NOTE : Raven olarak geçici set edildi
    localStorage.setItem("ClientId", 1);//Raven
    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  // handleValidSubmit
  handleValidSubmit(values) {
    this.props.loginUser(values, this.props.history);
  }

  handleInputSwitchChange = () => {
    this.setState(prevState => ({
      checked: !prevState.checked
    }));
  }

  componentDidMount() {
    this.props.loginApiError("");
    let tempLang = localStorage.getItem("I18N_LANGUAGE");
    let tempLang2 = localStorage.getItem("i18nextLng");
    localStorage.clear();
    localStorage.setItem("I18N_LANGUAGE", tempLang);
    localStorage.setItem("i18nextLng", tempLang2);
  }

  componentDidUpdate(prevProps) {
    const { error } = this.props;
    const { record } = this.state;
    if (prevProps.error !== error) {
      if (error) {
        if (error.response && error.response.data != '') {
          let a = JSON.parse(error.response.data);
          record.code = a.Code;
          record.message = a.Message;
        }
        else if (error) {
          record.code = error.code;
          record.message = error.message;
        } else {
          record.code = "Unhandled Exeption";
          record.message = "Please contact with Administrator";
        }
        this.setState({ error: record });
      }
    }
  }

  renderErrorMessages(errors) {
    const { t } = this.props;
    const { error } = this.state;
  
    const validationMessages = Object.values(errors).flatMap((msg) => {
      if (typeof msg === "string") return [msg];
      if (Array.isArray(msg)) return msg.filter(m => typeof m === "string");
      return [];
    });
  
    const requiredMsg = t("errors.required");
    const messagesToRender = validationMessages.includes(requiredMsg)
      ? [requiredMsg]
      : validationMessages;
  
    if (!error && messagesToRender.length === 0) return null;
  
    return (
      <Message
        severity="error"
        className="d-flex justify-content-start gap-1 mb-4"
        content={
          <>
            <img src={errorIcon} />
            <div>
              <b>{t("common.error")}:</b>
              <ul style={{ margin: 0, paddingLeft: "1.2rem" }}>
                {messagesToRender.map((msg, idx) => (
                  <li key={`validation-${idx}`}>{msg}</li>
                ))}
                {error?.message && (
                  <li key="server-error">{t(error.message)}</li>
                )}
              </ul>
            </div>
          </>
        }
      />
    );
  }
  
  renderFormFields(errors, touched, setFieldValue) {
    const { t } = this.props;
  
    return (
      <>
        <div className="form-subtitle">{t("login.welcomeTitle")}</div>
        <div className="form-title">{t("login.welcomeSubTitle")}</div>
        <Row>
          <Col lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("email")}</Label>
              <Field
                name="username"
                type="text"
                className={`form-control ${errors.username && touched.username ? "is-invalid" : ""}`}
                placeholder={t("common.email")}
                onChange={(e) => {
                  setFieldValue("username", e.target.value);
                  this.setState({ error: null });
                }}
              />
            </div>
          </Col>
          <Col lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("password")}</Label>
              <Field
                name="password"
                type="password"
                className={`form-control ${errors.password && touched.password ? "is-invalid" : ""}`}
                placeholder={t("common.password")}
                onChange={(e) => {
                  setFieldValue("password", e.target.value);
                  this.setState({ error: null });
                }}
              />
            </div>
          </Col>
        </Row>
      </>
    );
  }
  
  renderFooter() {
    const { t } = this.props;
    return (
      <Col lg={12}>
        <div className="d-flex align-items-center justify-content-between py-2">
          <div className="remember-me">
            <InputSwitch
              checked={this.state.checked}
              onChange={this.handleInputSwitchChange}
            />
            <span>{t("common.rememberMe")}</span>
          </div>
          <Link to="/passwordChange" className="forgot-password">
            {t("common.forgotMyPassword")}
          </Link>
        </div>
        <div className="mt-3 d-grid">
          <br />
          <button
            className="login-button"
            type="submit"
            style={{ backgroundColor: "#AB63BF", color: "#FAF3FD" }}
          >
            {t("login")}
          </button>
        </div>
      </Col>
    );
  }
  
  render() {
    const { t } = this.props;
  
    const initialValues = { username: "", password: "" };
    const validationSchema = Yup.object().shape({
      username: Yup.string()
        .strict(true)
        .max(50, t("maxLengthError").format("50"))
        .required(t("errors.required"))
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/,
          this.props.t("invalidEmail")
        ),
      password: Yup.string()
        .max(256, t("maxLengthError").format("256"))
        .min(6, t("minLengthError").format("6"))
        .required(t("errors.required")),
    });
  
    return (
      <React.Fragment>
        <Container>
          <Row className="justify-content-center">
            <div className="p-2">
              <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={values => this.handleValidSubmit(values)}
              >
                {({ errors, touched, setFieldValue }) => (
                  <Form>
                    {this.renderErrorMessages(errors)}
                    {this.renderFormFields(errors, touched, setFieldValue)}
                    {this.renderFooter()}
                  </Form>
                )}
              </Formik>
            </div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
  
}

Login.propTypes = {
  loginApiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  t: PropTypes.any,
};

const mapStateToProps = state => {
  const { loginApiError, error } = state.Login;
  return { loginApiError, error };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, loginApiError })(
    withTranslation()(Login),
  ),
);
